import { SvgIcon, SvgIconProps } from "@mui/joy";
import { forwardRef } from "react";

const AppIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg
        width="40"
        height="41"
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g style={{ mixBlendMode: "multiply" }}>
          <rect y="0.5" width="40" height="40" rx="9.75" fill="url(#paint0_radial_3_4874)" />
          <rect y="0.5" width="40" height="40" rx="9.75" fill="url(#pattern0_3_4874)" />
        </g>
        <path
          d="M19.0995 21.3216L18.3867 23.0961C18.3867 23.0961 22.5751 23.4938 22.5762 23.504L23.0479 21.4344C22.8957 21.4189 19.0995 21.3216 19.0995 21.3216Z"
          fill="#28EE77"
        />
        <path
          d="M25.3562 12.3016L19.6733 9.56055C18.5112 8.99844 17.1741 9.08332 16.1003 9.78077C15.0166 10.4792 14.3648 11.6699 14.359 12.9907L14.3057 27.92C14.3026 28.9723 14.7714 29.9249 15.5976 30.5419C16.2931 31.0588 17.1374 31.2614 17.9572 31.1262C18.1151 31.0998 18.2721 31.0631 18.427 31.0061L22.1275 29.7724C23.3607 29.3578 24.2719 28.3469 24.5822 27.057L25.2483 24.2352C25.3956 23.6117 25.2683 22.9543 24.883 22.4264C24.5907 22.023 24.1907 21.7441 23.7257 21.6162L22.593 26.5586C22.4515 27.1403 22.0469 27.6045 21.4829 27.7858L17.7823 29.0194C17.4428 29.1366 17.0745 29.071 16.7911 28.8524C16.4977 28.6348 16.3331 28.301 16.3354 27.9295L16.3997 13.0093C16.3978 12.401 16.6858 11.8766 17.1845 11.5472C17.6842 11.2281 18.2727 11.1886 18.8109 11.4431L24.4949 14.1944C24.8118 14.3477 24.9974 14.6898 24.9533 15.0449L25.1118 17.2874L26.6395 17.9876L26.9703 15.3239C27.1325 14.0593 26.4865 12.8464 25.3562 12.3016Z"
          fill="white"
        />
        <defs>
          <pattern
            id="pattern0_3_4874"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use xlinkHref="#image0_3_4874" transform="translate(-0.214086) scale(0.000348675)" />
          </pattern>
          <radialGradient
            id="paint0_radial_3_4874"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(36.5333 8.51852 -30.9482 22.1481 3.46667 3.65904)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1E1C54" />
            <stop offset="1" stopColor="#161541" />
          </radialGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
});

AppIcon.displayName = "Warning";

export default AppIcon;
